<!--  -->
<template>
  <div class="activeybox">
    <div v-for="element,index in list" :key="index" class="activebox" :style="{ backgroundColor: `${element.backgroundColor}` }" @click="chooser(element)">
      <img :src="element.background" alt="" class="imgaew">
      <div :style="{ color: `${element.fontColor}` }" class="activityamount">该区域展示选择的活动金额</div>
      <div :style="{ color: `${element.fontColor}` }" class="region">该区域展示选择的活动时间</div>
      <div class="btn_box">
        <img :src="element.button" alt="" class="btn_img">
      </div>
      <div :style="{ color: `${element.fontColor}` }" class="sderas">
        <div>温馨提示</div>
        <div class="saer">1.此充值为书币充值。</div>
        <div class="saer">2.书币为虚拟物品，不支持退款。</div>
        <div class="saer">3.免费书币有效期为3天。</div>
        <div class="saer">4.活动最终解释权归本公司所有。</div>
      </div>

    </div>

  </div>
</template>

<script>
import { acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      platformId: null,
      type: null,
      list: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(sendplatformId, type) {
      console.log('send', sendplatformId)
      this.platformId = sendplatformId
      this.type = type
      this.getlistr()
    },
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformId,
        activityType: this.type
      })
      this.list = data.data.theme
      console.log('data', data)
    },
    chooser(val) {
      console.log('val', val)
      this.$emit('callbacktemp', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activeybox{
  display: flex;
  flex-wrap: wrap;
      height: 680px;
    overflow: hidden;
    overflow-y: scroll;
}
.activebox{
  width: 200px;
  margin: 15px;
  position: relative;
}
.imgaew{
  width: 100%;
  height: 133px;
}
.region{
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
}
.btn_box{
   width: 100%;
   text-align: center;
   margin-top: 20px;
}
.btn_img{
  width: 100px;
  height: 30px;
}
.saer{
  font-size: 12px;
  margin-top: 10px;
}
.sderas{
  margin-top: 15px;
  padding-left: 15px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.activityamount{
  position: absolute;
  top: 96px;
  left: 18px;
}
</style>
